import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateCategoryV3 = OpalApi<'CreateCategoryV3', 201>

export const createCategory: CreateCategoryV3 = async (args = {}) => {
  const url = new URL('/loupe/v3/categories/', window.location.origin)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
